export const outcomeOptions = [
  { label: 'Active', value: 'true' },
  { label: 'Inactive', value: 'false' },
];

export const defaultWorkflowName = 'Untitled';

export const refetchDelay = 2000;
